import { LegacyButton } from '../LegacyButton';
import { DarkBackgroundButton } from '../../navigation/DarkBackgroundButton';
import { LegacyIconButton } from '../LegacyIconButton';
import { DarkBackgroundIconButton } from '../../navigation/DarkBackgroundIconButton';

type Props = {
  /**
   * Screenreader text. Be sure to pass this prop if `children` is empty!
   */
  'aria-label'?: string;
  /**
   * @deprecated
   * ### Use `'aria-label'` instead.
   *
   * Screenreader text. Be sure to pass this prop if `children` is empty!
   */
  ariaLabel?: string;
  /**
   * The text to render next to the back button.
   */
  children?: string;
  /**
   * Where the back button should link to.
   */
  href?: string;
  /**
   * If the button appears on a dark background -- V5 only
   */
  isOnDarkBackground?: boolean;
  /**
   * Optional click handler.
   */
  onClick?: React.MouseEventHandler;
  /**
   * Controls the size of `BackButton`, impacting its dimensions and typography.
   */
  size?: 'compact' | 'small' | 'medium' | 'large';
  /**
   * Optional text to render in a `Tooltip` for when the button renders only as an icon.
   */
  tooltipText?: string;
};

/**
 * ⚠️ DEPRECATED ⚠️
 * ================
 *
 * ### Use `Button` with `iconStart` and `href` instead
 *
 * _Button β_ will be possible as a replacement after
 * [DS-2463](https://zapierorg.atlassian.net/browse/DS-2463) is completed.
 *
 * ---
 *
 * Use `BackButton` to direct users to a higher-level page, such as a directory.
 * The content should reflect the title of the higher-level page.
 *
 * ---
 *
 * @deprecated
 */
export const BackButton = ({
  ariaLabel: deprecatedAriaLabel,
  'aria-label': ariaLabel = deprecatedAriaLabel,
  children,
  href,
  isOnDarkBackground,
  onClick,
  size = 'small',
  tooltipText,
}: Props) => {
  const sharedProps = {
    'aria-label': ariaLabel,
    href: href,
    onClick: onClick,
  };
  const ButtonComponent = isOnDarkBackground
    ? DarkBackgroundButton
    : LegacyButton;

  if (children) {
    return (
      <ButtonComponent
        {...sharedProps}
        color="secondary"
        iconBefore="arrowBigLeft"
        size={size}
      >
        {children}
      </ButtonComponent>
    );
  } else {
    if (isOnDarkBackground) {
      return (
        <DarkBackgroundIconButton
          {...sharedProps}
          color="icon-secondary"
          icon="arrowBigLeft"
          label={tooltipText}
          tooltipPosition="east"
        />
      );
    } else {
      return (
        <LegacyIconButton
          {...sharedProps}
          color="icon-alt"
          icon="arrowBigLeft"
          label={tooltipText}
          tooltipPosition="east"
        />
      );
    }
  }
};
